import { UnitCursor } from './cursor';
import { StringOutput } from './output';
var Item = (function () {
    function Item() {
    }
    Item.prototype.isDefined = function () {
        return true;
    };
    Item.prototype.isDistinct = function () {
        return true;
    };
    Item.prototype.isEmpty = function () {
        return false;
    };
    Item.prototype.stringValue = function (orElse) {
        return orElse;
    };
    Item.prototype.numberValue = function (orElse) {
        return orElse;
    };
    Item.prototype.booleanValue = function (orElse) {
        return orElse;
    };
    Item.prototype.concat = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var record = Item.empty();
        record.push(this);
        for (var i = 0, n = items.length; i < n; i += 1) {
            var item = Item.fromAny(items[i]);
            item.forEach(function (item) {
                record.push(item);
            });
        }
        return record;
    };
    Item.prototype.withField = function (key, newValue) {
        var record = Item.empty(2);
        record.push(this);
        return record.withField(key, newValue);
    };
    Item.prototype.withAttr = function (key, newValue) {
        var record = Item.empty(2);
        record.push(this);
        return record.withAttr(key, newValue);
    };
    Item.prototype.withSlot = function (key, newValue) {
        var record = Item.empty(2);
        record.push(this);
        return record.withSlot(key, newValue);
    };
    Item.prototype.withItem = function (newItem) {
        var record = Item.empty(2);
        record.push(this);
        return record.withItem(newItem);
    };
    Item.prototype.withItems = function () {
        var newItem = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newItem[_i] = arguments[_i];
        }
        var record = Item.empty(1 + arguments.length);
        record.push(this);
        return record.withItems.apply(record, arguments);
    };
    Item.prototype.forEach = function (callback, thisArg) {
        return callback.call(thisArg, this, 0);
    };
    Item.prototype.iterator = function () {
        return new UnitCursor(this);
    };
    Item.prototype.lt = function (that) {
        that = Item.of(that);
        return this.compare(that) < 0 ? Item.True : Item.Absent;
    };
    Item.prototype.le = function (that) {
        that = Item.of(that);
        return this.compare(that) <= 0 ? Item.True : Item.Absent;
    };
    Item.prototype.eq = function (that) {
        that = Item.of(that);
        return this.equals(that) ? Item.True : Item.Absent;
    };
    Item.prototype.ne = function (that) {
        that = Item.of(that);
        return !this.equals(that) ? Item.True : Item.Absent;
    };
    Item.prototype.ge = function (that) {
        that = Item.of(that);
        return this.compare(that) >= 0 ? Item.True : Item.Absent;
    };
    Item.prototype.gt = function (that) {
        that = Item.of(that);
        return this.compare(that) > 0 ? Item.True : Item.Absent;
    };
    Item.prototype.filter = function (predicate) {
        var selector = Item.Selector.literal(this);
        return selector.filter.apply(selector, arguments);
    };
    Item.prototype.max = function (that) {
        return this.compare(that) >= 0 ? this : that;
    };
    Item.prototype.min = function (that) {
        return this.compare(that) <= 0 ? this : that;
    };
    Item.prototype.evaluate = function (stack) {
        return this;
    };
    Item.prototype.substitute = function (stack) {
        return this;
    };
    Object.defineProperty(Item.prototype, "precedence", {
        get: function () {
            return 11;
        },
        enumerable: true,
        configurable: true
    });
    Item.prototype.writeReconBlock = function (output) {
        return this.writeRecon(output);
    };
    Item.prototype.toRecon = function () {
        var output = new StringOutput();
        this.writeRecon(output);
        return output.bind();
    };
    Item.prototype.toReconBlock = function () {
        var output = new StringOutput();
        this.writeReconBlock(output);
        return output.bind();
    };
    Item.prototype.writeString = function (output) {
        output.push(this.toString());
    };
    Item.Recon = undefined;
    Item.Field = undefined;
    Item.Attr = undefined;
    Item.Slot = undefined;
    Item.Value = undefined;
    Item.Record = undefined;
    Item.Data = undefined;
    Item.Text = undefined;
    Item.Num = undefined;
    Item.Bool = undefined;
    Item.DynamicValue = undefined;
    Item.Selector = undefined;
    Item.IdentitySelector = undefined;
    Item.LiteralSelector = undefined;
    Item.GetSelector = undefined;
    Item.GetAttrSelector = undefined;
    Item.GetItemSelector = undefined;
    Item.KeysSelector = undefined;
    Item.ChildrenSelector = undefined;
    Item.DescendantsSelector = undefined;
    Item.FilterSelector = undefined;
    Item.Func = undefined;
    Item.Expr = undefined;
    Item.CondExpr = undefined;
    Item.LorExpr = undefined;
    Item.LandExpr = undefined;
    Item.BorExpr = undefined;
    Item.BxorExpr = undefined;
    Item.BandExpr = undefined;
    Item.LtExpr = undefined;
    Item.LeExpr = undefined;
    Item.EqExpr = undefined;
    Item.NeExpr = undefined;
    Item.GeExpr = undefined;
    Item.GtExpr = undefined;
    Item.AddExpr = undefined;
    Item.SubExpr = undefined;
    Item.MulExpr = undefined;
    Item.DivExpr = undefined;
    Item.ModExpr = undefined;
    Item.LnotExpr = undefined;
    Item.BnotExpr = undefined;
    Item.NegExpr = undefined;
    Item.PosExpr = undefined;
    Item.InvokeExpr = undefined;
    Item.Empty = undefined;
    Item.True = undefined;
    Item.False = undefined;
    Item.Extant = undefined;
    Item.Absent = undefined;
    Item.GlobalScope = undefined;
    Item.empty = undefined;
    Item.of = undefined;
    Item.fromAny = undefined;
    return Item;
}());
export { Item };
//# sourceMappingURL=data:application/json;base64,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